function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.3 19.9a.99.99 0 101.4 1.4l4.593-4.593a1 1 0 000-1.414L15.7 10.7a.99.99 0 10-1.4 1.4l3.9 3.9-3.9 3.9z",
  fill: "#6F8190"
});

var SvgIconArrowRight = function SvgIconArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC4zIDE5LjlDMTMuOTEzNCAyMC4yODY2IDEzLjkxMzQgMjAuOTEzNCAxNC4zIDIxLjNDMTQuNjg2NiAyMS42ODY2IDE1LjMxMzQgMjEuNjg2NiAxNS43IDIxLjNMMjAuMjkyOSAxNi43MDcxQzIwLjY4MzQgMTYuMzE2NiAyMC42ODM0IDE1LjY4MzQgMjAuMjkyOSAxNS4yOTI5TDE1LjcgMTAuN0MxNS4zMTM0IDEwLjMxMzQgMTQuNjg2NiAxMC4zMTM0IDE0LjMgMTAuN0MxMy45MTM0IDExLjA4NjYgMTMuOTEzNCAxMS43MTM0IDE0LjMgMTIuMUwxOC4yIDE2TDE0LjMgMTkuOVoiIGZpbGw9IiM2RjgxOTAiLz4KPC9zdmc+Cg==";
export { SvgIconArrowRight as ReactComponent };